import { html } from '@microsoft/fast-element';
import type { Text } from './text.js';

export default html<Text>`
	<slot></slot>
`;